// Mobile menu toggle + scroll lock
const menuButton = document.querySelector('#ToggleMobileMenu');
const siteNav = document.querySelector('.site-nav');
const html = document.documentElement;
const body = document.body;

let scrollY = 0;

menuButton.addEventListener('click', () => {
  const isOpen = siteNav.classList.contains('is-open');

  if (!isOpen) {
    scrollY = window.scrollY;

    siteNav.classList.add('is-open');
    menuButton.classList.add('open');

    html.classList.add('menu-open');
    body.classList.add('menu-open');

    body.style.top = `-${scrollY}px`;
  } else {
    siteNav.classList.remove('is-open');
    menuButton.classList.remove('open');

    html.classList.remove('menu-open');
    body.classList.remove('menu-open');

    body.style.top = '';

    window.scrollTo(0, scrollY);
  }
});

// Progress Bar
function updateProgressBar(cartTotal, itemCount) {
  const progressWrapper = document.getElementById('cart-progress-wrapper');
  if (!progressWrapper) return;

  const moneyFormat = progressWrapper.dataset.moneyFormat;
  const progressThreshold = parseInt(progressWrapper.dataset.threshold, 10);
  const preGoalMessageTemplate = progressWrapper.dataset.preGoalMessageTemplate;
  const postGoalMessage = progressWrapper.dataset.postGoalMessage;

  const progressBar = document.getElementById('cart-progress-bar');
  const goalMessageElements = document.querySelectorAll('.goal-message');

  if (itemCount === 0 || cartTotal === 0) {
    progressWrapper.style.display = 'none';
    goalMessageElements.forEach(el => el.style.display = 'none');
  } else {
    progressWrapper.style.display = 'block';
    if (progressBar) {
      progressBar.style.display = 'block';
      const progressPercentage = Math.min((cartTotal / progressThreshold) * 100, 100);
      progressBar.style.width = `${progressPercentage}%`;
      progressWrapper.classList.toggle('full', progressPercentage >= 100);
    }

    goalMessageElements.forEach(el => {
      el.style.display = 'block';
      let remainingForGoal = progressThreshold - cartTotal;
      if (remainingForGoal < 0) remainingForGoal = 0;

      const remainingAmount = (remainingForGoal / 100).toFixed(2);
      const remainingAmountFormatted = `£${remainingAmount}`;
      const preGoalMessage = preGoalMessageTemplate.replace('[remaining_for_goal]', remainingAmountFormatted);

      el.innerHTML = remainingForGoal > 0 ? preGoalMessage : postGoalMessage;
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('Cart fetched:', cart);
      updateProgressBar(cart.total_price, cart.item_count);
    });
});


// Cart Drawer
function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();

  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();

  updateCartItemCounts(cart.item_count);
  updateProgressBar(cart.total_price, cart.item_count);  
}

async function updateMainCart() {
  const res = await fetch("/?section_id=main-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newMainCart = html.querySelector(".main-cart");
  const currentMainCart = document.querySelector(".main-cart");
  if (newMainCart && currentMainCart) {
    currentMainCart.innerHTML = newMainCart.innerHTML;
    addCartDrawerListeners(); // Re-bind quantity buttons
  }

  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();
  updateCartItemCounts(cart.item_count);
  updateProgressBar(cart.total_price, cart.item_count);
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem = button.closest("[data-line-item-key]");
        const key = rootItem.getAttribute("data-line-item-key");

        const currentQuantity = Number(
          rootItem.querySelector("input").value
        );
        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update both views if they exist
        if (document.querySelector(".cart-drawer")) updateCartDrawer();
        if (document.querySelector(".main-cart")) updateMainCart();
      });
    });

    // Prevent closing when clicking inside the drawer box
    const drawerBox = document.querySelector(".cart-drawer-box");
    if (drawerBox) {
      drawerBox.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }
    
    // Close drawer when clicking the background overlay
    const drawer = document.querySelector(".cart-drawer");
    if (drawer) {
      drawer.addEventListener("click", (e) => {
        if (e.target === drawer) {
          closeCartDrawer();
        }
      });
    }
    
    // Close drawer when clicking the close button
    document.querySelectorAll(".cart-drawer-header-right-close").forEach((btn) => {
      btn.addEventListener("click", closeCartDrawer);
    });
}

addCartDrawerListeners();

// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Update cart
//     await updateCartDrawer();

//     // Open cart drawer
//     openCartDrawer();
//   });
// });

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    });

    const item = await res.json();

    // Fire Shopify Analytics event safely
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
      window.ShopifyAnalytics.lib.track("product_added_to_cart", {
        variant_id: item.variant_id,
        name: item.product_title,
        price: item.price / 100,
        quantity: item.quantity,
        sku: item.sku,
        brand: item.vendor,
      });
      console.log("ShopifyAnalytics: product_added_to_cart", item);
    }

    await updateCartDrawer();
    openCartDrawer();
  });
});

document.querySelectorAll('.top-bar a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});
